import { newE2EPage } from '@stencil/core/testing';

describe('jackery-accordion', () => {
  it('renders', async () => {
    const page = await newE2EPage();
    await page.setContent('<jackery-accordion></jackery-accordion>');

    const element = await page.find('jackery-accordion');
    expect(element).toHaveClass('hydrated');
  });
});
